import React from 'react';

var Filter = (function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#120A20' : _ref$color,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '24' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.523 0 10 1.567 10 3.5v.727a2 2 0 01-.52 1.345L14 15.8V21c0 .522-.799.95-1.818.996L12 22c-1.105 0-2-.448-2-1v-5.201L2.52 7.572A2 2 0 012 6.227V5.5l.005-.113C2.176 3.507 6.585 2 12 2zm0 2c-4.142 0-7.5.672-7.5 1.5S7.858 7 12 7c4.142 0 7.5-.672 7.5-1.5S16.142 4 12 4z",
    fill: color,
    fillRule: "evenodd"
  }));
});

export { Filter as default };
//# sourceMappingURL=filter.js.map
